<div class="wrapper has-padding">
  <!-- set focus when pressing skiplink button -->
  <div tabindex="-1" #vendorSearchElement class="bofa--skiplink">
  </div>
  <h2 class="bofa--heading is-5 is-stacked">Background Screening Results Search Screen</h2>
  <form [formGroup]="vendorSearchResultsForm">
    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space">
      <mat-card-content>
        <div class="flex-row-wrap">
          <mat-form-field class="vc-search-field-width">
            <mat-label>Case Number</mat-label>
            <input matInput formControlName="caseNumber">
            <mat-error>Please enter a valid Case Number</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Applicant First Name</mat-label>
            <input matInput formControlName="applicantFirstName">
            <mat-error>Please enter a valid Applicant First Name</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Applicant Last Name</mat-label>
            <input matInput formControlName="applicantLastName">
            <mat-error>Please enter a valid Applicant Last Name</mat-error>
          </mat-form-field>
        </div>

        <div class="flex-row-wrap">
          <mat-form-field class="vc-search-field-width">
            <mat-label>Reference Number</mat-label>
            <input matInput formControlName="referenceNumber">
            <mat-error>Please enter a valid Reference Number</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Requester First Name</mat-label>
            <input matInput formControlName="requesterFirstName">
            <mat-error>Please enter a valid Requester First Name</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Requester Last Name</mat-label>
            <input matInput formControlName="requesterLastName">
            <mat-error>Please enter a valid Requester Last Name</mat-error>
          </mat-form-field>
        </div>

        <div class="flex-row-wrap">
          <mat-form-field class="vc-search-field-width">
            <mat-label>SSN</mat-label>
            <input matInput formControlName="ssn">
            <mat-error>Please enter a valid SSN</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Company Code/Cost Center</mat-label>
            <input matInput formControlName="companyCode">
            <mat-error>Please enter a valid Company Code/Cost Center</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width">
            <mat-label>Vendor Name</mat-label>
            <input matInput formControlName="vendorName">
            <mat-error>Please enter a valid Vendor Name</mat-error>
          </mat-form-field>
        </div>

        <div class="flex-row-wrap">
          <p class="label-width">Case Ordered Date (MM/DD/YYYY):</p>

          <mat-form-field class="vc-search-field-width hint-padding">
            <mat-label><span class="hide">Case Ordered </span>Start Date</mat-label>
            <input matInput formControlName="caseOrderStartDate" [matDatepicker]="startDatePicker" [min]="minDate"
              [max]="maxDate" time="false">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            <mat-error>Please enter valid start date in the format mm/dd/yyyy</mat-error>
          </mat-form-field>

          <mat-form-field class="vc-search-field-width hint-padding">
            <mat-label><span class="hide">Case Ordered </span>End Date</mat-label>
            <input matInput formControlName="caseOrderEndDate" [matDatepicker]="endDatePicker" [min]="minDate"
              [max]="maxDate" time="false">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            <mat-error>Please enter valid end date in the format mm/dd/yyyy</mat-error>
          </mat-form-field>
        </div>
        <div class="actions">
          <button type="button" (click)="onReset()" class="bofa--button secondary dark-blue large">Clear</button>
          <button type="button" (click)="onSearch()"
          class="bofa--button primary large ui-font no-margin-right">Search</button>
        </div>
      </mat-card-content>
    </mat-card>
  </form>

  <!-- Hide the element when no search is done yet -->
  @if (displayResult) {
    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space margin-top">
      <div class="textalign-right margin-top-1em">
        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)">
        </mat-form-field>
        <button type="button" (click)="exportAsExcel()" class="bofa--button secondary dark-blue medium">Export</button>
      </div>
      <span class="hide" role="alert" aria-live="polite">Displaying search results</span>
      <span class="hide" id="tableDesc">Search results</span>
      <mat-card-content class="overflow-x-auto" #TABLE>
        <table aria-describedby="tableDesc" mat-table [dataSource]="dataSource" class="mat-elevation-z" matSort #table>
          <ng-container matColumnDef="caseNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Case Number </th>
            <td mat-cell *matCellDef="let case">
              <a href="javascript: void(0);" (click)="onTakeAction(case)" aria-label="open case {{case.caseNumber}}">{{case.caseNumber}}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="referenceNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Reference Number </th>
            <td mat-cell *matCellDef="let case"> {{case.referenceNumber}} </td>
          </ng-container>
          <ng-container matColumnDef="applicantName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Applicant Name </th>
            <td mat-cell *matCellDef="let case"> {{case.applicantName}} </td>
          </ng-container>
          <ng-container matColumnDef="requesterName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header acope="col"> Requester Name </th>
            <td mat-cell *matCellDef="let case"> {{case.requesterName}} </td>
          </ng-container>
          <ng-container matColumnDef="comp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Components Requested </th>
            <td mat-cell *matCellDef="let case"> {{case.comp}} </td>
          </ng-container>
          <ng-container matColumnDef="appointmentDetails">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Appointment Details </th>
            <td mat-cell *matCellDef="let case"> {{case.appointmentDetails}} </td>
          </ng-container>
          <ng-container matColumnDef="caseStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Case Status </th>
            <td mat-cell *matCellDef="let case"> {{case.caseStatus}} </td>
          </ng-container>
          <ng-container matColumnDef="statusDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Status Date </th>
            <td mat-cell *matCellDef="let case"> {{case.statusDate}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        @if (!dataSource.data.length) {
          <div class="textalign-center-margintop-marginbottom">
            No items to display
          </div>
        }
      </mat-card-content>
      <mat-paginator aria-label="Vendor search results pagination" [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
    </mat-card>
  }
</div>